import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import CenterState, {CenterList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import httpRequest from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<CenterState, State> = {
  async getCenterList(
    { commit, dispatch, state }: ActionContext<CenterState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'center', options, (res: CenterList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
}

export default actions
